import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Popover, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Icon from "@shared/components/Icon";
import React from "react";
import NavigationItem, { capitalizeFirstLetter, styleMenuItemLink, } from "./NavigationItem";
const styleMenuItem = {
    cursor: "pointer",
    position: "relative",
};
const styleSubMenu = {
    mt: 2,
    p: 1.5,
    bgcolor: "background.paper",
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.12)",
};
const SubMenus = ({ subMenus, isMobile, }) => {
    return (_jsx(Stack, { spacing: 0, children: subMenus.map((item) => {
            return (_jsx(NavigationItem, { menuItem: item, depth: 1, sx: {
                    color: isMobile ? "primary.contrastText" : "text.primary",
                    fontSize: "15px",
                    px: 2,
                    py: 1.5,
                    borderRadius: 0,
                    justifyContent: "flex-start",
                    transition: "background-color 200ms ease",
                    "&:hover, &:focus-visible": {
                        backgroundColor: "background.grey",
                        textDecoration: "none",
                        "& .NavigationItem-label::after": {
                            transform: "scaleX(0) !important",
                        },
                    },
                } }, item.id));
        }) }));
};
const NavigationGroup = ({ menuItem = {}, subMenus, ...others }) => {
    const { title, subtext = "" } = menuItem;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const handleClickGroup = React.useCallback((event) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(true);
    }, []);
    const closeMenuGroup = React.useCallback(() => {
        setIsOpen(false);
    }, []);
    // L'ancre est conservée jusqu'à la fin de l'animation : sans elle, le Popover se repositionne sur le body (bas de page) au changement de page
    const handleExited = React.useCallback(() => {
        setAnchorEl(null);
    }, []);
    const handlePopoverClick = React.useCallback((event) => {
        event.stopPropagation();
        closeMenuGroup();
    }, [closeMenuGroup]);
    return (_jsx(Box, { ...others, children: _jsxs(Box, { sx: styleMenuItem, onClick: handleClickGroup, children: [_jsxs(Stack, { spacing: 1, direction: "row", tabIndex: 0, "aria-haspopup": "true", "aria-expanded": isOpen ? "true" : undefined, "aria-controls": isOpen ? `menu-group-${menuItem.id}` : undefined, sx: {
                        alignItems: "center",
                        justifyContent: { xs: "flex-start", md: "center" },
                    }, children: [_jsx(Typography, { sx: styleMenuItemLink, variant: "subtitle1", color: "colors.lynch", component: "div", children: _jsxs(Stack, { spacing: 0.5, alignItems: "flex-start", children: [_jsx("span", { className: "NavigationItem-label", children: capitalizeFirstLetter(title) }), subtext && (_jsx(Typography, { component: "span", variant: "body2", color: "text.secondary", sx: { fontSize: "13px", fontWeight: 400 }, children: capitalizeFirstLetter(subtext) }))] }) }), _jsx(Icon, { icon: "chevron-down", type: "fal", title: isOpen ? "Fermer" : "Ouvrir", style: {
                                marginLeft: 8,
                                fontSize: "1.14rem",
                                display: "flex",
                                alignItems: "center",
                                transform: `rotate(${isOpen ? 180 : 0}deg)`,
                                transition: "transform linear 200ms",
                            } })] }), isMobile ? (_jsx(Box, { id: `menu-group-${menuItem.id}`, sx: { display: isOpen ? "block" : "none", mt: 2 }, children: _jsx(SubMenus, { subMenus: subMenus, isMobile: isMobile }) })) : (_jsx(Popover, { open: isOpen, anchorEl: anchorEl, onClose: closeMenuGroup, onClick: handlePopoverClick, disableScrollLock: true, hideBackdrop: true, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    }, slotProps: {
                        paper: {
                            id: `menu-group-${menuItem.id}`,
                            sx: styleSubMenu,
                        },
                        transition: {
                            onExited: handleExited,
                        },
                    }, children: _jsx(SubMenus, { subMenus: subMenus, isMobile: isMobile }) }))] }) }));
};
export default NavigationGroup;
